'use client'

import React, { useEffect, useState } from 'react'
import { BookOpen } from 'lucide-react'
import { useDocumentationContext } from './documentation-provider'
import { UntitledBadge } from '@/components/ui/untitled-badge'
import { cn } from '@/lib/utils'

export function DocumentationFAB() {
  const { isOpen, openWithContext, hasSeenDocs, markAsSeen } = useDocumentationContext()
  const [showPulse, setShowPulse] = useState(false)

  useEffect(() => {
    // Show pulse animation for new users
    if (!hasSeenDocs && !isOpen) {
      setShowPulse(true)
    } else {
      setShowPulse(false)
    }
  }, [hasSeenDocs, isOpen])

  const handleClick = () => {
    openWithContext()
    if (!hasSeenDocs) {
      markAsSeen()
      setShowPulse(false)
    }
  }

  // Don't show button if panel is open
  if (isOpen) return null

  return (
    <div className="fixed bottom-6 left-6 md:left-auto md:right-6 z-40">
      {/* Subtle pulse animation for new users */}
      {showPulse && (
        <div className="absolute inset-0 rounded-full bg-purple-600 animate-soft-pulse" />
      )}
      
      <button
        onClick={handleClick}
        className={cn(
          "relative group",
          "px-4 py-3 rounded-full",
          "bg-purple-600 hover:bg-purple-700",
          "text-white",
          "shadow-lg hover:shadow-xl",
          "transition-all duration-200",
          "flex items-center gap-2",
          "focus:outline-none focus:ring-2 focus:ring-purple-500 focus:ring-offset-2"
        )}
        aria-label="Open User Guide"
      >
        <BookOpen className="h-5 w-5" />
        <span className="font-medium">User Guide</span>
        {!hasSeenDocs && (
          <UntitledBadge status="NEW" variant="modern" className="bg-white/20 text-white border-white/30" />
        )}
      </button>
    </div>
  )
}